import { axios } from "@Root/API";

export const getRecordsOfStudies = params => {
  return axios.get("students/course-session", { params });
};
